import { CommonService } from 'dashboard-services/services';
import { globalActions } from 'primary-components';

import { settingsMyAccountActions } from 'actions/modules/myAccount';
import properties from 'resources/constants/properties.json';
import { clearLocalStorage } from 'services/LocalStorageService';

const getAuthToken = () => (_, getState) => getState().primaryComponentsState.loginState.token
const getWithWareHouseService = () => (_, getState) => {
  if(properties.warehouse_only === "true" || properties.warehouse_hybrid === "true"){
    return getState()?.myAccountState?.settingsState?.warehouse
  } else {
    return settingsMyAccountActions.WAREHOUSE.OFF
  }
}

const commonApiConfig = ({ mcp = false } = {}) => dispatch => ({
  getAuthToken: () => dispatch(getAuthToken()),
  handleRequest: (...params) => dispatch(globalActions.handleRequest(...params)),
  onLogOut: () => {
    clearLocalStorage()
    dispatch({ type: 'LOG_OUT' })
  },
  baseUrl: mcp ? properties.baseUrl.mcp : properties.baseUrl.api,
  clearLocalStorage,
  withWareHouseService: () => dispatch(getWithWareHouseService()),
})

const getApiConfig = (options = {}) => dispatch => ({
  ...dispatch(commonApiConfig(options)),
  fetch: window.fetch.bind(window)
})

export const getThrottledApiConfig = (numberOfCalls = 5, timeout = 1000) => dispatch => ({
  ...dispatch(commonApiConfig()),
  fetch: CommonService.throttle(window.fetch.bind(window), numberOfCalls, timeout)
})

export default getApiConfig;
